import React from 'react';
import AgendContasContent from './AgendContasContent';
import { AgendContasContext } from './Context';

export const AgendamentoDeContas: React.FC = () => {
  return (
    <AgendContasContext>
      <AgendContasContent />
    </AgendContasContext>
  );
};
